<template>
  <div v-if="infobox" class="model-infobox flex flex-col gap-10 lg:grid lg:grid-cols-[520px_1fr] lg:gap-10">
    <div class="model-infobox__image">
      <SharedPicture
        fit="contain"
        imageClass="!rounded-sm"
        :media="infobox.image"
        :width="642"
        :height="642"
        :quality="80"
        fetchpriority="high"
        loading="eager"
        class="block sm:hidden"
      />
      <SharedPicture
        fit="contain"
        imageClass="!rounded-sm"
        :media="infobox.image"
        :width="757"
        :height="757"
        :quality="80"
        fetchpriority="high"
        loading="eager"
        class="hidden sm:block lg:hidden"
      />
      <SharedPicture
        fit="contain"
        imageClass="!rounded-sm"
        :media="infobox.image"
        :width="520"
        :height="520"
        :quality="80"
        fetchpriority="high"
        loading="eager"
        class="hidden lg:block"
      />
    </div>
    <div class="model-infobox__text">
      <h2 v-if="infobox.title" class="model-infobox__title">
        {{ infobox.title }}
      </h2>

      <div v-if="infobox.description" class="model-infobox__description my-6" v-html="infobox.description"></div>

      <div class="model-infobox__content flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:gap-5">
        <div class="model-infobox__content-item">
          <h6 v-if="infobox.col1title">{{ infobox.col1title }}</h6>
          <div v-if="infobox.col1text" class="model-infobox__content-item-text mt-4" v-html="infobox.col1text"></div>
        </div>
        <div class="model-infobox__content-item">
          <h6 v-if="infobox.col2title">{{ infobox.col2title }}</h6>
          <div v-if="infobox.col2text" class="model-infobox__content-item-text mt-4" v-html="infobox.col2text"></div>
        </div>
      </div>

      <div class="model-infobox__buttons flex flex-wrap gap-4 mt-8" v-if="infobox.ctas?.ctas?.length">
        <PageComponentsCtas :component="{ __typename: 'ComponentPageComponentsCTAs', ctas: infobox.ctas.ctas || [] }" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLModel } from '~/types/graphql';

  const props = defineProps<{
    infobox: GraphQLModel['infobox'];
  }>();
</script>

<style></style>
